import React, { Component } from 'react';
import { observer, inject } from "mobx-react";
import { withRouter, NavLink } from "react-router-dom";
import RightPanelOptions from './RightPanelOptions';
let store = null;
var self = null;
@inject("appStore")
@observer
class PersonalProjects extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {
        return (
            <section class="o-section  t-section  ">

                <div class="o-section__header-bg  t-section__header"></div>
                <div class="o-section__content-bg  t-section__content"></div>

                <div class="o-container">
                    <div class="o-section__container">

                        <header class="o-section__header  t-section__header">
                            <div class="o-content">
                                <h2 class="o-section__heading">
                                    Personal Projects
                                </h2>
                                <div class="o-content__body  o-section__description">
                                    Building AI-powered platforms, automation systems, and enterprise tools with full-stack and cloud-native capabilities.
                                </div>
                            </div>
                        </header>

                        <div class="o-section__content  t-section__content  u-pt-0">

                            <div class="o-content">
                                <div class="a-education-timeline  c-timeline  t-border-color  o-section__full-top-space">
                                    <div class="c-timeline__end  t-border-color"></div>

                                    <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        Resume Screener – LLM-Powered Candidate Evaluation
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Built an AI-driven resume screening system with a React.js UI for recruiters to visualize candidate rankings and skill summaries.
                                                            </li>
                                                            <li>
                                                                Extracted key skills, experience, and achievements using LLMs, generating structured evaluation reports.
                                                            </li>
                                                            <li>
                                                                Improved enterprise hiring efficiency by automating candidate evaluation workflows.
                                                            </li>
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: OpenAI, Bedrock, LangChain, Python, Node.js, React.js
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        Auto RCA for AWS Serverless Services
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Developed an automated Root Cause Analysis system for AWS Lambda, CodeBuild, and other serverless services.
                                                            </li>
                                                            <li>
                                                                LLM-powered system interprets logs, metrics, and error patterns, generating actionable remediation guidance.
                                                            </li>
                                                            <li>
                                                                Reduced incident resolution time and improved operational reliability.
                                                            </li>
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: AWS Lambda, CloudWatch, Step Functions, Python, LLMs
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        CloudWise – Multi-Cloud Intelligent Chat Interface
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Built a GenAI chat platform with React.js UI for querying AWS, GCP, and Azure.
                                                            </li>
                                                            <li>
                                                                Provides cost analysis, security review, log interpretation, and billing optimization via interactive dashboards.
                                                            </li>
                                                            <li>
                                                                Backend powered by MCP servers for scalable multi-cloud AI reasoning.
                                                            </li>
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: AWS, GCP, Azure, LangGraph, LangChain, Bedrock, React.js
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        Custom MCP Server for Confluence Automation
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Developed a custom MCP server that enables AI agents to automatically create and update Confluence pages.
                                                            </li>
                                                            <li>
                                                                Streamlined enterprise documentation workflows, including templates and structured knowledge management.
                                                            </li>
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: Python, Bedrock, LangGraph, Confluence API
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        SonarQube Auto-Fix Bot
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Built an AI agent that automatically analyzes SonarQube findings, applies code fixes, and creates GitHub branches.
                                                            </li>
                                                            <li>
                                                                Reduced developer effort in code remediation and improved code quality across projects.
                                                            </li>
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: OpenAI, Bedrock, Python, GitHub API, Node.js
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        Agentic AI Workflows
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Implemented autonomous multi-agent workflows using LangGraph, including Planner–Executor–Reviewer architectures.
                                                            </li>
                                                            <li>
                                                                Enabled multi-step reasoning, tool calling, and task orchestration for enterprise processes.
                                                            </li>
                                                            
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: LangGraph, LangChain, LlamaIndex, HuggingFace, Python, LLMs
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        GenAI Code Documentation Generator
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                 Built a system to analyze codebases and auto-generate documentation, including architecture diagrams.
                                                            </li>
                                                            <li>
                                                                Helps teams onboard faster and understand legacy systems with minimal manual effort.
                                                            </li>
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: OpenAI, Bedrock, Python, Node.js, draw.io
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        Template-Based Research Agent
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Developed an agent that performs internet research, synthesizes findings, and fills predefined templates in DOCX format.
                                                            </li>
                                                            <li>
                                                                Streamlines report and whitepaper creation for enterprise and research use cases.
                                                            </li>
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: OpenAI, LangChain, Python, DOCX
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        Bedrock–OpenAI Proxy
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Designed a serverless proxy layer allowing OpenAI SDKs to integrate with AWS Bedrock.
                                                            </li>
                                                            <li>
                                                                Abstracted provider details while enabling secure, scalable inference pipelines.
                                                            </li>
                                                            
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: AWS Lambda, API Gateway, Bedrock, OpenAI
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        Text-to-Architecture Diagram Generator
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Built a GenAI chatbot that converts natural language system descriptions into draw.io-compatible architecture diagrams.
                                                            </li>
                                                            <li>
                                                                Simplifies system design visualization and communication for engineering teams.
                                                            </li>
                                                            
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: Bedrock, LangChain, draw.io, Python
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        Feedback Analytics System
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                               Built a platform for aspect-based sentiment analysis with interactive dashboards/UI for stakeholders.
                                                            </li>
                                                            <li>
                                                                Generates structured insights and visualizes trends for enterprise feedback evaluation.
                                                            </li>
                                                            
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: Python, HuggingFace Quantized LLMs, LangChain, React.js and AWS
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        RAG Chatbot over Confluence
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Developed a Retrieval-Augmented Generation (RAG) chatbot over Confluence documentation for enterprise knowledge discovery.
                                                            </li>
                                                            <li>
                                                                Provides contextual answers and accelerates information retrieval.
                                                            </li>
                                                            
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: Bedrock, LangChain, LlamaIndex, CDK, AWS Aurora Serverless Database, Python etc.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        GraphRAG over Confluence
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Extended RAG into GraphRAG, enabling relationship-aware, multi-hop reasoning across documentation.
                                                            </li>
                                                            <li>
                                                                Improves enterprise knowledge retrieval by understanding contextual links between documents.
                                                            </li>
                                                            <li>
                                                                Improved enterprise hiring efficiency by automating candidate evaluation workflows.
                                                            </li>
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: GraphDB like Neptune, Opensource GraphRag, Bedrock, LangChain, LlamaIndex, CDK, AWS Aurora Serverless Database, Python etc.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        TalkingSlides – AI-Powered Presentation Video Generator
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Transformed static PPTs into AI-generated videos with realistic avatars, voice narration, synchronized subtitles, and interactive slide UI.
                                                            </li>
                                                            <li>
                                                                Fully automated slide-to-video generation pipeline for enterprise presentations.
                                                            </li>
                                                            
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: Python, HuggingFace Models, Text-to-Speech, Video Synthesis, etc.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="c-timeline__item">
                                        <div class="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                                        <div class="o-content">
                                            <div class="o-grid">
                                                <div class="o-grid__col-md-12">

                                                    <h3 class="c-work__heading">
                                                        AI Personal Blogger
                                                    </h3>
                                                    <p>
                                                        <ul>
                                                            <li>
                                                                Built an AI agent that researches topics online and generates blog posts automatically.
                                                            </li>
                                                            <li>
                                                                Integrated UI dashboards to review and edit content before publication, creating a seamless content pipeline.
                                                            </li>
                                                            
                                                        </ul>
                                                    </p>
                                                    <p>
                                                        Technologies: Bedrock, LangChain, Python, React.js, HuggingFace Models
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     
                                    

                                    

                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </section>

        );
    }
}

export default withRouter(PersonalProjects);